const removeHtmlTags = (content) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(content, "text/html");
  return doc.body.textContent || doc.body.innerText || "";
};

export { removeHtmlTags };
